import React from 'react';
import { Building2, Edit, Trash2 } from 'lucide-react';

const PlantList = ({ plants, editingPlant, onEdit, onDelete }) => (
  <div className="bg-white rounded-lg shadow-md p-4 sm:p-6">
    <h3 className="text-base sm:text-lg font-semibold text-gray-900 mb-4">Existing Plants ({plants.length})</h3>
    <div className="space-y-3">
      {plants.map(plant => {
        const isEditing = editingPlant?.id === plant.id;
        const rowClass = `flex flex-col sm:flex-row sm:items-center sm:justify-between p-3 sm:p-4 gap-3 border-2 rounded-lg transition-colors ${
          isEditing ? 'border-orange-400 bg-orange-50' : 'border-gray-200 hover:border-indigo-300'
        }`;
        return (
          <div key={plant.id} className={rowClass} data-testid={`plant-row-${plant.id}`}>
            <div className="flex items-center space-x-3 sm:space-x-4 min-w-0">
              <Building2 className="h-8 w-8 sm:h-10 sm:w-10 text-indigo-600 flex-shrink-0" />
              <div className="min-w-0">
                <h4 className="font-semibold text-gray-900 truncate">{plant.name}</h4>
                <p className="text-sm text-gray-600 truncate">{plant.location || 'No location specified'}</p>
              </div>
            </div>
            <div className="flex gap-2">
              <button
                onClick={() => onEdit(plant)}
                className="flex-1 sm:flex-none bg-orange-500 hover:bg-orange-600 text-white px-4 py-2 min-h-[44px] rounded-lg transition-colors flex items-center justify-center"
                title="Edit Plant"
                data-testid={`edit-plant-${plant.id}`}
              >
                <Edit className="h-5 w-5 mr-1" /> Edit
              </button>
              <button
                onClick={() => onDelete(plant.id)}
                className="flex-1 sm:flex-none bg-red-500 hover:bg-red-600 text-white px-4 py-2 min-h-[44px] rounded-lg transition-colors flex items-center justify-center"
                title="Delete Plant"
                data-testid={`delete-plant-${plant.id}`}
              >
                <Trash2 className="h-5 w-5 mr-1" /> Delete
              </button>
            </div>
          </div>
        );
      })}
    </div>
  </div>
);

export default PlantList;
